<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.店铺名称')" prop="shopName">
                <a-input v-model="queryParam.shopName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('店铺.店铺名称')"
                         allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.店铺状态是否开启')" prop="shopState">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.店铺状态')" style="width: 100%" v-model="queryParam.shopState" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
                        <a-col :md="6" :sm="24">
                          <a-form-item :label="$t('是否是品牌店铺')" prop="se">
                            <a-select :placeholder="$t('通用.输入.请选择')+$t('是否是品牌店铺')" style="width: 100%" v-model="queryParam.shopRecommend" allowClear>
                              <a-select-option v-for="(item, index) in this.customDict.YesNoStatusEnum" :value="item.type"
                                               :key="index">
                                {{ item.name }}
                              </a-select-option>
                            </a-select>
                          </a-form-item>
                        </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('店铺.入驻类型')" prop="se">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('店铺.入驻类型')" style="width: 100%" v-model="queryParam.settleType" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.ShopSettleTypeEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                  type="redo"/>{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl"/>
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
              <a-button type="primary" @click="handleAdd()" v-hasPermi="['shop:shop:add']">
                <a-icon type="plus" />{{$t('通用.按钮.新增')}}
              </a-button>
        <!--   <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['shop:shop:edit']">
       <a-icon type="edit" />{{$t('通用.按钮.修改')}}
     </a-button>
     <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shop:shop:remove']">
       <a-icon type="delete" />{{$t('通用.按钮.删除')}}
     </a-button>
     <table-setting
       :style="{float: 'right'}"
       :table-size.sync="tableSize"
       v-model="columns"
       :refresh-loading="loading"
       @refresh="getList" />
       -->
   </div>
      <!-- 增加修改 -->
<!--      <create-form
        ref="createForm"
        @ok="getList"
      />-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="shopCreateTime" slot-scope="text, record">
          {{ parseTime(record.shopCreateTime) }}
        </span>
        <span slot="shopEndTime" slot-scope="text, record">
          {{ parseTime(record.shopEndTime) }}
        </span>
        <template slot="shopLogo" slot-scope="text, record">
          <div>
            <img v-if="record.shopLogo" :src="record.shopLogo" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.shopLogo)" alt="none"/>
          </div>
        </template>
        <template slot="shopBackground" slot-scope="text, record">
          <div>
            <img v-if="record.shopBackground" :src="record.shopBackground" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.shopBackground)" alt="none"/>
          </div>
        </template>
        <span slot="shopRecommend" slot-scope="text, record">
          <a-switch @change="(checked) => onShopRecommendChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.shopRecommend === 1"/>
        </span>

<!--        <span v-if="record.settleType==2" slot="isStudy" slot-scope="text, record">-->
        <span  slot="isStudy" slot-scope="text, record">
          <a-switch @change="(checked) => onStudyChange(checked,record)" :checked-children="$t('通用.文本.是')"
                    :un-checked-children="$t('通用.文本.否')" :checked="record.isStudy === 1"/>
        </span>
        <span slot="settleType" slot-scope="text, record">
             {{ record.settleTypeName }}
        </span>
        <span slot="shopType" slot-scope="text, record">
             {{ record.shopTypeName }}
        </span>
        <span slot="shopStateName" slot-scope="text, record">
             {{ record.shopStateName }}
        </span>
        <span slot="openStatus" slot-scope="text, record">
                       <custom-dict-tag :options="customDict.AccountOpenStatusEnum" :value="record.openStatus"/>
        </span>
        <span slot="categoryId" slot-scope="text, record">
            {{ getCategoryNameById(record.categoryId) }}
          </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="recommendTime" slot-scope="text, record">
          {{ parseTime(record.recommendTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
<!--          <a  v-if="record.openStatus == '' ||  record.openStatus == '0' || record.openStatus == '-1'" @click="openShopAccount(record)">-->
<!--               <a-icon type="edit"/>{{ $t('开通钱包') }}-->
<!--          </a>-->
<!--          <a @click="jumpLakala(record)">-->
<!--               <a-icon type="ordered-list"/>子商户-->
<!--          </a>-->
          <a-divider type="vertical" v-if="showManualApply(record)" v-hasPermi="['shop:extraapplylakala:edit']"/>
          <a @click="handleManualApply(record)" v-if="showManualApply(record)" v-hasPermi="['shop:extraapplylakala:edit']">
               <a-icon type="form"/>手动进件
          </a>
          <a-divider type="vertical" v-if="showLedgerApply(record)" v-hasPermi="['shop:extraapplylakala:edit']"/>
          <a @click="handleLedgerApply(record)" v-if="showLedgerApply(record)" v-hasPermi="['shop:extraapplylakala:edit']">
               <a-icon type="account-book"/>开通分账
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:edit']"/>
          <a @click="handleUpdate(record, undefined)" v-hasPermi="['shop:shop:edit']">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:lakalBalance']"/>
          <a @click="$refs.lakalaBalance.handleDetail(record.id)" v-if="record.termNo" v-hasPermi="['shop:shop:lakalBalance']">
               <a-icon type="eye"/>拉卡拉分账账户信息
          </a>
<!--          <a @click="handleDeductDeposit(record)" v-hasPermi="['shop:shop:edit']">-->
<!--               <a-icon type="minus-circle"/>{{ $t('扣除保证金') }}-->
<!--          </a>-->
          <!--
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:shop:edit']">
               <a-icon type="edit"/>{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:remove']"/>
          <a @click="handleDelete(record)" v-hasPermi="['shop:shop:remove']">
               <a-icon type="delete"/>{{ $t('通用.按钮.删除') }}
          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <!-- 扣除保证金弹窗 -->
    <a-modal
      :title="$t('扣除保证金')"
      :visible="deductDepositVisible"
      :confirmLoading="deductDepositLoading"
      @ok="handleDeductDepositOk"
      @cancel="deductDepositVisible = false"
      :okText="$t('确认')"
      :cancelText="$t('通用.按钮.取消')"
      width="500px"
    >
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item :label="$t('店铺.店铺名称')">
          <span>{{ deductDepositForm.shopName }}</span>
        </a-form-item>
        <a-form-item :label="$t('当前保证金余额')">
          <span>{{ deductDepositForm.currentAmount }}</span>
        </a-form-item>
        <a-form-item :label="$t('扣除金额')" required>
          <a-input-number
            v-model="deductDepositForm.amount"
            :min="0.01"
            :max="deductDepositForm.currentAmount || 999999"
            :precision="2"
            :placeholder="$t('请输入扣除金额')"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :label="$t('扣除原因')">
          <a-textarea
            v-model="deductDepositForm.deductReason"
            :placeholder="$t('请输入扣除原因')"
            :maxLength="200"
            :rows="3"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 手动进件弹窗 -->
    <a-modal
      title="手动进件"
      :visible="manualApplyVisible"
      :confirmLoading="manualApplyLoading"
      @ok="handleManualApplyOk"
      @cancel="manualApplyVisible = false"
      :okText="$t('确认')"
      :cancelText="$t('通用.按钮.取消')"
      width="500px"
    >
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="店铺名称">
          <span>{{ manualApplyForm.shopName }}</span>
        </a-form-item>
        <a-form-item label="商户号" required>
          <a-input
            v-model="manualApplyForm.merchantNo"
            placeholder="请输入拉卡拉商户号(merchant_no)"
            :maxLength="64"
          />
        </a-form-item>
        <a-form-item label="终端号" required>
          <a-input
            v-model="manualApplyForm.termNo"
            placeholder="请输入终端号(term_no)"
            :maxLength="64"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 开通分账弹窗 -->
    <a-modal
      :title="$t('店铺.开通分账')"
      :visible="ledgerApplyVisible"
      :confirmLoading="ledgerApplyLoading"
      @ok="handleLedgerApplyOk"
      @cancel="handleLedgerApplyCancel"
      :okText="$t('确认')"
      :cancelText="$t('通用.按钮.取消')"
      width="640px"
      :destroyOnClose="true"
    >
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item :label="$t('店铺.店铺名称')">
          <span>{{ ledgerApplyForm.shopName }}</span>
        </a-form-item>
        <a-form-item :label="$t('店铺.联系手机号')" required>
          <a-input
            v-model="ledgerApplyForm.contactMobile"
            :maxLength="11"
            :placeholder="$t('店铺.请输入联系手机号')"
          />
        </a-form-item>
        <a-form-item :label="$t('店铺.最低分账比例')" required>
          <a-input-number
            v-model="ledgerApplyForm.splitLowestRatio"
            :min="0"
            :max="100"
            :precision="2"
            :placeholder="$t('店铺.请输入最低分账比例')"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :label="$t('店铺.分账结算委托书')">
          <oss-upload-single v-model="ledgerApplyForm.splitEntrustFilePath" prefix="shop"></oss-upload-single>
          <div style="color: #999; font-size: 12px; line-height: 1.6;">{{ $t('店铺.委托书提示') }}</div>
        </a-form-item>
        <a-form-item :label="$t('店铺.电子合同编号')">
          <a-input
            v-model="ledgerApplyForm.eleContractNo"
            :maxLength="64"
            :placeholder="$t('店铺.请输入电子合同编号')"
          />
        </a-form-item>
        <a-form-item :label="$t('店铺.分账范围')">
          <a-select v-model="ledgerApplyForm.splitRange">
            <a-select-option value="ALL">{{ $t('店铺.全部交易分账') }}</a-select-option>
<!--            <a-select-option value="MARK">{{ $t('店铺.标记交易分账') }}</a-select-option>-->
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('店铺.分账依据')">
          <a-select v-model="ledgerApplyForm.sepFundSource">
            <a-select-option value="TR">{{ $t('店铺.交易分账') }}</a-select-option>
<!--            <a-select-option value="BA">{{ $t('店铺.余额分账') }}</a-select-option>-->
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('店铺.分账发起方式')">
          <a-select v-model="ledgerApplyForm.splitLaunchMode">
<!--            <a-select-option value="AUTO">{{ $t('店铺.自动规则分账') }}</a-select-option>-->
<!--            <a-select-option value="POINTRULE">{{ $t('店铺.指定规则分账') }}</a-select-option>-->
            <a-select-option value="MANUAL">{{ $t('店铺.手动分账') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('店铺.提款类型')">
          <a-select v-model="ledgerApplyForm.settleType">
<!--            <a-select-option value="01">{{ $t('店铺.主动提款') }}</a-select-option>-->
            <a-select-option value="03">{{ $t('店铺.交易自动结算') }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 查看账户余额 -->
    <lakala-balance ref="lakalaBalance"></lakala-balance>
  </page-header-wrapper>
</template>

<script>
import {pageShop, listShop, delShop, updateShopRecommend,updateIsStudy,openShopAccount,deductDeposit} from '@/api/shop/shop'
import {manualApply, lakalaLedgerApplyByParam} from '@/api/shop/extraApplyLakala'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import LakalaBalance from '../lakalaApply/modules/LakalaBalance'
import OssUploadSingle from '@/components/OssUploadSingle'
import {tableMixin} from '@/store/table-mixin'
import {listShopCategory} from "@/api/shop/shopCategory";
import bus from "@/utils/bus";

export default {
  name: 'Shop',
  components: {
    CustomDictTag,
    CreateForm,
    LakalaBalance,
    OssUploadSingle
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      categoryList: [{id: "0", categoryName: ''}],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 扣除保证金弹窗
      deductDepositVisible: false,
      deductDepositForm: {
        shopId: undefined,
        amount: undefined,
        deductReason: undefined
      },
      deductDepositLoading: false,
      // 手动进件弹窗
      manualApplyVisible: false,
      manualApplyLoading: false,
      manualApplyForm: {
        shopId: undefined,
        shopName: undefined,
        merchantNo: undefined,
        termNo: undefined
      },
      // 开通分账弹窗
      ledgerApplyVisible: false,
      ledgerApplyLoading: false,
      ledgerApplyForm: {
        shopId: undefined,
        shopName: undefined,
        contactMobile: undefined,
        splitLowestRatio: undefined,
        splitEntrustFilePath: undefined,
        eleContractNo: undefined,
        splitRange: 'ALL',
        sepFundSource: 'TR',
        splitLaunchMode: 'MANUAL',
        settleType: '03'
      },
      // 查询参数
      queryParam: {
        shopName: undefined,
        shopLogo: undefined,
        shopBackground: undefined,
        shopKeywords: undefined,
        shopQc: undefined,
        timeOfEntry: undefined,
        shopAreap: undefined,
        shopAreac: undefined,
        shopAreax: undefined,
        shopAddress: undefined,
        longitude: undefined,
        latitude: undefined,
        shopDescription: undefined,
        kfPhone: undefined,
        companyType: undefined,
        settleType: undefined,
        shopType: undefined,
        shopRecommend: undefined,
        isStudy: undefined,
        userId: undefined,
        categoryId: undefined,
        shopState: undefined,
        shopCloseInfo: undefined,
        shopCollect: undefined,
        attentionNum: undefined,
        shopAccount: undefined,
        settlementAccount: undefined,
        shopCreateTime: undefined,
        shopEndTime: undefined,
        goodsDescribeScore: undefined,
        shopDescribeScore: undefined,
        logisticsScore: undefined,
        shopScore: undefined,
        thatViews: undefined,
        kfAccount: undefined,
        alarmGoodsStock: undefined,
        alarmGoodsSkuStock: undefined,
        weatherBzj: undefined,
        moneyBzj: undefined,
        platformRatio: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        contactsEmail: undefined,
        contactsCardNo: undefined,
        contactsCardHand: undefined,
        contactsCardFace: undefined,
        contactsCardCountry: undefined,
        businessLicenceNumber: undefined,
        companyName: undefined,
        companyAreap: undefined,
        companyAreac: undefined,
        companyAreax: undefined,
        companyAddressDetail: undefined,
        socialCreditCode: undefined,
        authCertificate: undefined,
        businessSphere: undefined,
        businessLicenceNumberElectronic: undefined,
        bankCardNoType: undefined,
        settlementBankUserName: undefined,
        settlementBankAccountNumber: undefined,
        bankUserPhone: undefined,
        settlementBankAccountName: undefined,
        settlementBankName: undefined,
        settlementBankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        trademarkCertificate: undefined,
        shopProtocol: undefined,
        businessLicense: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('店铺id'),
          dataIndex: 'id',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('店铺.店铺名称'),
          dataIndex: 'shopName',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('店铺.店铺logo'),
          dataIndex: 'shopLogo',
          ellipsis: true,
          scopedSlots: {customRender: 'shopLogo'},
          align: 'center'
        },
        {
          title: this.$t('店铺.店铺背景图'),
          dataIndex: 'shopBackground',
          ellipsis: true,
          scopedSlots: {customRender: 'shopBackground'},
          align: 'center'
        },
        {
          title: this.$t('店铺.客服电话'),
          dataIndex: 'kfPhone',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.入驻时长'),
        //   dataIndex: 'duration',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('店铺.入驻类型'),
          dataIndex: 'settleType',
          scopedSlots: {customRender: 'settleType'},
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.店铺类型'),
        //   dataIndex: 'shopType',
        //   scopedSlots: {customRender: 'shopType'},
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('是否是品牌店铺'),
          dataIndex: 'shopRecommend',
          // sorter: 1,
          ellipsis: true,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: {customRender: 'shopRecommend'},
          align: 'center'
        },
        {
          title: this.$t('设置品牌店铺时间'),
          dataIndex: 'recommendTime',
          ellipsis: true,
          scopedSlots: {customRender: 'recommendTime'},
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.店铺分类'),
        //   dataIndex: 'categoryId',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'categoryId'},
        //   align: 'center'
        // },
        // {
        //   title: this.$t('能否发布线下活动'),
        //   dataIndex: 'isStudy',
        //   sorter: 1,
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'isStudy'},
        //   align: 'center'
        // },
        {
          title: this.$t('店铺.平台抽成比例'),
          dataIndex: 'platformRatio',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('店铺.账户余额'),
          dataIndex: 'shopAccount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保证金余额',
          dataIndex: 'moneyBzj',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '服务费金额',
          dataIndex: 'moneyServiceFee',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('店铺.已结算金额'),
          dataIndex: 'settlementAccount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('店铺.店铺状态'),
          dataIndex: 'shopState',
          ellipsis: true,
          scopedSlots: {customRender: 'shopStateName'},
          align: 'center'
        },
        // {
        //   title: this.$t('店铺.钱包开通状态'),
        //   dataIndex: 'openStatus',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'openStatus'},
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '13%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getCategoryList();
    /**编辑页面接收到更新的数据 */
    bus.$on('updateShopList',()=>{
      this.getList()
    })
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
    methods: {
    jumpLakala(record) {
      this.$router.push({
        path: '/shop/lakalaApply',
        query: { shopId: record.id, companyType: record.companyType || 1 }
      })
    },
    /** 打开手动进件弹窗 */
    handleManualApply(record) {
      this.manualApplyVisible = true
      this.manualApplyForm = {
        shopId: record.id,
        shopName: record.shopName,
        merchantNo: record.merchantNo || undefined,
        termNo: record.termNo || undefined
      }
    },
    /** 确认手动进件 */
    handleManualApplyOk() {
      if (!this.manualApplyForm.merchantNo) {
        this.$message.warning('请输入商户号')
        return
      }
      if (!this.manualApplyForm.termNo) {
        this.$message.warning('请输入终端号')
        return
      }
      this.manualApplyLoading = true
      const data = {
        shopId: this.manualApplyForm.shopId,
        merchantNo: this.manualApplyForm.merchantNo,
        termNo: this.manualApplyForm.termNo
      }
      manualApply(data).then(response => {
        if (response.success) {
          this.$message.success('手动进件成功', 3)
          this.manualApplyVisible = false
          this.getList()
        } else {
          this.$message.error(response.msg || '手动进件失败', 3)
        }
      }).finally(() => {
        this.manualApplyLoading = false
      })
    },
    /** 是否已开通分账（WAIT-申请中、VALID-已启用） */
    hasLedgerOpened(record) {
      return record.splitStatus === 'WAIT' || record.splitStatus === 'VALID'
    },
    /** 是否显示手动进件按钮：已开通分账后不再显示 */
    showManualApply(record) {
      return !this.hasLedgerOpened(record)
    },
    /** 是否显示开通分账按钮：有终端号且未开通分账 */
    showLedgerApply(record) {
      return !!record.termNo && !this.hasLedgerOpened(record)
    },
    /** 打开开通分账弹窗 */
    handleLedgerApply(record) {
      this.ledgerApplyForm = {
        shopId: record.id,
        shopName: record.shopName,
        contactMobile: undefined,
        splitLowestRatio: undefined,
        splitEntrustFilePath: undefined,
        eleContractNo: undefined,
        splitRange: 'ALL',
        sepFundSource: 'TR',
        splitLaunchMode: 'MANUAL',
        settleType: '03'
      }
      this.ledgerApplyVisible = true
    },
    /** 关闭开通分账弹窗 */
    handleLedgerApplyCancel() {
      this.ledgerApplyVisible = false
    },
    /** 确认开通分账 */
    handleLedgerApplyOk() {
      if (!this.ledgerApplyForm.contactMobile) {
        this.$message.warning(this.$t('店铺.请输入联系手机号'))
        return
      }
      if (!/^1[3-9]\d{9}$/.test(this.ledgerApplyForm.contactMobile)) {
        this.$message.warning(this.$t('店铺.手机号格式错误'))
        return
      }
      if (this.ledgerApplyForm.splitLowestRatio === undefined || this.ledgerApplyForm.splitLowestRatio === null) {
        this.$message.warning(this.$t('店铺.请输入最低分账比例'))
        return
      }
      if (!this.ledgerApplyForm.splitEntrustFilePath && !this.ledgerApplyForm.eleContractNo) {
        this.$message.warning(this.$t('店铺.委托书或电子合同必填'))
        return
      }
      const data = {
        shopId: this.ledgerApplyForm.shopId,
        contactMobile: this.ledgerApplyForm.contactMobile,
        splitLowestRatio: this.ledgerApplyForm.splitLowestRatio,
        splitEntrustFilePath: this.ledgerApplyForm.splitEntrustFilePath || undefined,
        splitEntrustFileName: this.getFileNameFromUrl(this.ledgerApplyForm.splitEntrustFilePath),
        eleContractNo: this.ledgerApplyForm.eleContractNo || undefined,
        splitRange: this.ledgerApplyForm.splitRange || 'ALL',
        sepFundSource: this.ledgerApplyForm.sepFundSource || 'TR',
        splitLaunchMode: this.ledgerApplyForm.splitLaunchMode || 'MANUAL',
        settleType: this.ledgerApplyForm.settleType || '03'
      }
      this.ledgerApplyLoading = true
      lakalaLedgerApplyByParam(data).then(response => {
        if (response.success) {
          this.$message.success(this.$t('店铺.分账申请提交成功'), 3)
          this.ledgerApplyVisible = false
          this.getList()
        } else {
          this.$message.error(response.msg || this.$t('店铺.分账申请失败'), 3)
        }
      }).finally(() => {
        this.ledgerApplyLoading = false
      })
    },
    /** 从URL提取文件名 */
    getFileNameFromUrl(url) {
      if (!url) {
        return undefined
      }
      const arr = url.split('?')[0].split('/')
      return arr[arr.length - 1] || undefined
    },
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询店铺列表 */
    getList() {
      this.loading = true
      pageShop(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        shopName: undefined,
        shopLogo: undefined,
        shopBackground: undefined,
        shopKeywords: undefined,
        shopQc: undefined,
        timeOfEntry: undefined,
        shopAreap: undefined,
        shopAreac: undefined,
        shopAreax: undefined,
        shopAddress: undefined,
        longitude: undefined,
        latitude: undefined,
        shopDescription: undefined,
        kfPhone: undefined,
        companyType: undefined,
        settleType: undefined,
        shopType: undefined,
        shopRecommend: undefined,
        isStudy: undefined,
        userId: undefined,
        categoryId: undefined,
        shopState: undefined,
        shopCloseInfo: undefined,
        shopCollect: undefined,
        attentionNum: undefined,
        shopAccount: undefined,
        settlementAccount: undefined,
        shopCreateTime: undefined,
        shopEndTime: undefined,
        goodsDescribeScore: undefined,
        shopDescribeScore: undefined,
        logisticsScore: undefined,
        shopScore: undefined,
        thatViews: undefined,
        kfAccount: undefined,
        alarmGoodsStock: undefined,
        alarmGoodsSkuStock: undefined,
        weatherBzj: undefined,
        moneyBzj: undefined,
        platformRatio: undefined,
        contactsName: undefined,
        contactsPhone: undefined,
        contactsEmail: undefined,
        contactsCardNo: undefined,
        contactsCardHand: undefined,
        contactsCardFace: undefined,
        contactsCardCountry: undefined,
        businessLicenceNumber: undefined,
        companyName: undefined,
        companyAreap: undefined,
        companyAreac: undefined,
        companyAreax: undefined,
        companyAddressDetail: undefined,
        socialCreditCode: undefined,
        authCertificate: undefined,
        businessSphere: undefined,
        businessLicenceNumberElectronic: undefined,
        bankCardNoType: undefined,
        settlementBankUserName: undefined,
        settlementBankAccountNumber: undefined,
        bankUserPhone: undefined,
        settlementBankAccountName: undefined,
        settlementBankName: undefined,
        settlementBankAddress: undefined,
        accountInstCity: undefined,
        accountInstProvince: undefined,
        trademarkCertificate: undefined,
        shopProtocol: undefined,
        businessLicense: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delShop(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    onShopRecommendChange(checked, record) {
      let data = {id: record.id, shopRecommend: checked}
      updateShopRecommend(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.shopRecommend = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    openShopAccount(record){
      let data = {id: record.id}
      openShopAccount(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.提交成功'),
            3
          );
          this.$emit('ok')
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onStudyChange(checked, record){
      let data = {id: record.id, isStudy: checked}
      updateIsStudy(data).then(response => {
        if (response.success) {
          this.$message.success(
              this.$t('通用.文本.修改成功'),
              3
          );
          this.$emit('ok')
          record.isStudy = checked
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listShopCategory().then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },
    /*根据总后台还是店铺初始化加载页面数据*/
    getColumns() {
      // v-hasPermi="['shop:shop:add']"
    },
    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      this.$router.push({
        path: 'shopForm',
        query:
          {
            id: row.id
          }
      })
    },
    handleAdd() {
      this.$router.push({
        path: 'shopForm',
        query: {}
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('shop/shop/export',
            ...that.queryParam
            , `店铺_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    /** 打开扣除保证金弹窗 */
    handleDeductDeposit(record) {
      this.deductDepositVisible = true
      this.deductDepositForm = {
        shopId: record.id,
        shopName: record.shopName,
        currentAmount: parseFloat(record.moneyBzj) || 0,
        amount: undefined,
        deductReason: undefined
      }
    },
    /** 确认扣除保证金 */
    handleDeductDepositOk() {
      if (!this.deductDepositForm.amount) {
        this.$message.warning(this.$t('请输入扣除金额'))
        return
      }
      if (!this.deductDepositForm.deductReason) {
        this.$message.warning(this.$t('请输入扣除原因'))
        return
      }
      if (parseFloat(this.deductDepositForm.amount) > parseFloat(this.deductDepositForm.currentAmount)) {
        this.$message.warning(this.$t('扣除金额不能超过当前保证金余额'))
        return
      }
      this.deductDepositLoading = true
      const data = {
        shopId: this.deductDepositForm.shopId,
        amount: this.deductDepositForm.amount,
        deductReason: this.deductDepositForm.deductReason
      }
      deductDeposit(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.扣除成功'),
            3
          )
          this.deductDepositVisible = false
          this.getList()
        } else {
          this.$message.error(
            response.msg || this.$t('通用.文本.扣除失败'),
            3
          )
        }
      }).finally(() => {
        this.deductDepositLoading = false
      })
    }
  }
}
</script>
